import { useEffect } from 'react'
import { useForm, useFormState } from 'react-final-form'
import { useQuery } from '../../../hooks/useQuery'

/**
 * This component is used to add an alias value to the product form
 * based on the value of the 'alias' query param.  It should be called
 * inside of the final-form `Form` component so it has access to the forms
 * context.
 */
export const AddAliasFromQuery = () => {
  const { mutators } = useForm()
  const { initialValues } = useFormState()
  const query = useQuery()
  const aliasName = query.get('alias')

  useEffect(() => {
    if (aliasName === null) {
      return
    }
    mutators.push('aliases_attributes', { name: aliasName })
  }, [mutators, initialValues, aliasName])

  return null
}
